export default __webpack_public_path__ + "static/media/M12.8035d44e.svg";